import {
    DISTRIBUTOR_TOGGLE_DECISION_TABLE,
    DecisionTableProps,
    UserParameters,
    SwitchProps,
} from "constants/user/DistributorToggleDecisionTable";

const options: DecisionTableProps[] = DISTRIBUTOR_TOGGLE_DECISION_TABLE;

const findAuthUser = (opt: DecisionTableProps, userDetails: UserParameters) =>
    userDetails.authUser.type === opt.authUser.type
    && userDetails.authUser.isDistributor === opt.authUser.isDistributor
    && userDetails.user.type === opt.user.type
    && userDetails.user.isDistributor === opt.user.isDistributor
    && userDetails.viewEditSelf === opt.viewEditSelf;

export const getSwitchProps = (userDetails: UserParameters): SwitchProps => {
    const option = options.find(opt => findAuthUser(opt, userDetails));
    return {
        visible: option ? option.switchProps.visible : false,
        enabled: option ? option.switchProps.enabled : false,
    }
}